/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line import/extensions

import { ReviewPacketData } from '../SolicitorDocumentPage';
import { sealed } from './decorator/protector';

@sealed
export class VerticeSystem {
    public showSelectedSteps = false;

    public Threeshold = 0;

    public showStep = false;

    public percentageMatchThreeshold: number | undefined = undefined;

    protected type = '';

    protected percentageMatch?: string | undefined;

    protected object: ReviewPacketData | null = null;

    // eslint-disable-next-line no-underscore-dangle
    knownInstance(): boolean {
        return (
            (this.showSelectedSteps === true && this.showStep === false) !==
            true
        );
    }
}
